import ipaddr from 'ipaddr.js';

export function isLinkLocalIPv4(ip: string): boolean {
  return !!ip.match(/^169\.254/i);
}

export function isLinkLocalIPv6(ip: string): boolean {
  return !!ip.match(/^FE80/i);
}

export function reverseIp(ip: string): string {
  return ip.split('.').reverse().join('.');
}

export function getIpVersion(ip: string): 6 | 4 {
  let ipParsed;
  try {
    ipParsed = ipaddr.parse(ip);
  } catch (e) {
    ipParsed = null;
    return ipParsed;
  }
  return ipParsed.kind() === 'ipv6' ? 6 : 4;
}
